
import Vue from "vue"

// Put commas in a list of users (currently an object of objects as a result of wonky data-handling)
Vue.filter('commaSeparateUsers', (list, index) => `${list[index].first_name} ${list[index].last_name}${index === list.length - 1 ? '' : ','}`)



// WEBPACK FOOTER //
// ./src/filters/index.js